// Referidos del Club Frikytopia. Captura ?ref=CÓDIGO (first-touch → cookie 90 días) y, cuando el
// cliente está logueado, envía la atribución a nuestro backend. El padrino recibe +250 pts cuando
// este referido hace su primera compra (lo resuelve el webhook de pedidos en el servidor).
(function () {
  var API = 'https://frikyshop.fly.dev/api/club-public';
  var COOKIE = 'fkclub_ref';
  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]+)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  // 1) Capturar ?ref de la URL (first-touch: no pisar una cookie ya existente).
  try {
    var m = location.search.match(/[?&]ref=([0-9A-Za-z]+)/);
    if (m && m[1] && !getCookie(COOKIE)) {
      document.cookie = COOKIE + '=' + encodeURIComponent(m[1]) + ';path=/;max-age=' + (90 * 24 * 3600) + ';SameSite=Lax';
    }
  } catch (e) { /* */ }

  // 2) Si hay cliente logueado + cookie ref, atribuir (una sola vez por cliente+código).
  try {
    var cid = window.FRIKY_CUSTOMER_ID;
    if (!cid) return;
    var ref = getCookie(COOKIE);
    if (!ref) return;
    var mark = String(cid) + ':' + ref;
    if (localStorage.getItem('fkclub_ref_sent') === mark) return;
    fetch(API + '/refer', {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' }, // text/plain evita preflight CORS
      body: JSON.stringify({ customerId: String(cid), ref: ref }),
    })
      .then(function (r) { return r.json(); })
      .then(function (res) { if (res && res.ok) { try { localStorage.setItem('fkclub_ref_sent', mark); } catch (e) {} } })
      .catch(function () { /* */ });
  } catch (e) { /* */ }
})();
